import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
} from '@angular/material/dialog';
import {
  RunTransition,
  RunTransitionWithDialog,
  WorkflowService,
} from '../../services/workflow/workflow.service';
import { PayeePopupComponent } from '../../payee-popup/payee-popup.component';
import { PayeeFormFieldComponent } from '../../payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeInputDirective } from '../../payee-input/payee-input.directive';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-missing-data-general',
  templateUrl: './missing-data-general.component.html',
  styleUrls: ['./missing-data-general.component.scss'],
  imports: [
    PayeePopupComponent,
    PayeeFormFieldComponent,
    PayeeInputDirective,
    FormsModule,
    ReactiveFormsModule,
    PayeeButtonComponent,
    MatDialogClose,
    TranslateModule,
  ],
})
export class MissingDataGeneralComponent {
  private fb = inject(FormBuilder);
  private dialogRef =
    inject<MatDialogRef<MissingDataGeneralComponent>>(MatDialogRef);
  private data = inject<RunTransitionWithDialog>(MAT_DIALOG_DATA);
  private workflowService = inject(WorkflowService);

  loading = false;
  readonly message: FormControl<string | null>;

  constructor() {
    this.message = this.fb.control<string | null>(null, Validators.required);
  }

  private readonly getParams = () => {
    return {
      ...(this.data.extraParams ?? {}),
      message: this.message.value,
    };
  };

  async submit() {
    if (this.message.invalid) {
      this.message.markAsDirty();
      return;
    }

    const params = this.getParams();

    const closeValue: RunTransition = {
      caseId: this.data.caseId,
      transitionId: this.data.transitionId,
      params,
    };

    this.loading = true;
    try {
      await this.workflowService.runTransition(closeValue);
      this.dialogRef.close(closeValue);
    } catch (error) {
      this.workflowService.showTransitionError(error);
    } finally {
      this.loading = false;
    }
  }
}
